module.exports = __webpack_public_path__ + "img/cost-dots-mobile.49ee2de6.svg";